<div class="p-3">
  <div
    mat-dialog-title
    class="title-container drag-handle-header d-flex align-items-center mb-3"
    cdkDrag
    cdkDragRootElement=".draggable-dialog-container.general-popup-container"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
  >
    <mat-icon
      *ngIf="icon === MessageBoxIcon.Confirmation"
      svgIcon="confirmation"
      class="title-icon confirmation mr-3"
    ></mat-icon>
    <mat-icon
      *ngIf="icon === MessageBoxIcon.WarningTriangle"
      svgIcon="warning-triangle"
      class="title-icon primary mr-3"
    ></mat-icon>
    <h4 *ngIf="title" id="confirmation-dialog-title" class="flex-grow-1 m-0">
      {{ title }}
    </h4>
  </div>
  <div mat-dialog-content class="d-flex flex-grow-1">
    <div class="title-icon invisible mr-3"></div>
    <div class="content-container flex-grow-1">
      <p id="confirmation-dialog-message" *ngIf="message">{{ message }}</p>
      <mat-form-field
        *ngIf="showInput"
        class="inline-editable-editor input-grey-fill w-100 mt-3 auto-size"
        floatLabel="auto"
      >
        <textarea
          cdkFocusInitial
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="10"
          [formControl]="inputReasonForDeferral"
          id="input-reason-for-deferral"
          class="custom-scrollbar"
          placeholder="Please type your reason for deferral."
          tabIndex="0"
        ></textarea>
        <mat-error
          *ngIf="
            inputReasonForDeferral.invalid &&
            (inputReasonForDeferral.dirty || inputReasonForDeferral.touched)
          "
          class="invalid-feedback mt-0"
        >
          <div *ngIf="inputReasonForDeferral.errors?.required">
            Reason for deferral is required.
          </div>
          <div *ngIf="inputReasonForDeferral.errors?.whitespace">
            Reason for deferral does not accept only spaces.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div
    mat-dialog-actions
    class="section-actions d-flex flex-grow-1 justify-content-end w-100"
  >
    <button
      mat-stroked-button
      class="everbtn-slight-wide"
      id="confirm-deferral-btn"
      (click)="confirmDeferral()"
      type="button"
      tabIndex="0"
    >
      {{ buttonTextForConfirm || 'Confirm Deferral' }}
    </button>
    <button
      mat-stroked-button
      class="plain-button everbtn-slight-wide"
      id="close-btn"
      (click)="close()"
      type="button"
      tabIndex="1"
    >
      Close
    </button>
  </div>
</div>
